import script from "./CaptureSeats.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptureSeats.vue?vue&type=script&setup=true&lang=js"

import "./CaptureSeats.vue?vue&type=style&index=0&id=79d0188c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d0188c"]])

export default __exports__